import React, { Component } from 'react';
import {Link} from 'react-router-dom'; 

class Contact extends Component{
    render(){
        return(
            <div className="row">
                
            <div align="center" className="col-12" >
                <h1>Get In Touch</h1>
                <p align="center" className="col-md-6">Although I'm not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!</p>
                <Link to="/con"><button className=" getint" type="button">Say Hello</button></Link>
            </div>
            </div>
        )

    }
}

export default Contact;